import moment from 'moment';
import {
  FilterOptions,
  IFilterComparator,
  DateRangeFilterModel
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { DateRangeModelComparator } from './comparators/date-range-model-comparator';
import { FilterResultFacade } from '../filter-result-facade';
import { FilterPassParams } from '../filter-types';
import { FilterHandlerBase } from '../filter-handlers/base/filter-handler-base';

export class DateDateFilterHandler extends FilterHandlerBase {
  private comparator: DateRangeModelComparator;
  get name(): string {
    return CalendarGridColumnName.DatedDate;
  }

  hasValidDiff(
    options: FilterOptions,
    grid: Partial<DateRangeFilterModel>,
    store: DateRangeFilterModel
  ): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options: FilterOptions
  ): IFilterComparator<DateRangeFilterModel> {
    if (!this.comparator) {
      this.comparator = new DateRangeModelComparator();
    }
    return this.comparator;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade): boolean {
    let datedDateFilterPassed = true;

    const datedDate = params.filters[this.name];
    if (datedDate) {
      const { from, to } = params.filters[this.name].model;

      const dateFrom = moment.utc(from, 'MM/YYYY').startOf('month');
      const dateTo = moment.utc(to, 'MM/YYYY').endOf('month');
      const datedDates = params.deal.series.map(ea => ea.datedDate);
      if (datedDates.length) {
        datedDateFilterPassed = datedDates.some(
          ea => !!ea && ea.isBetween(dateFrom, dateTo)
        );
      }
    }
    result.applyDealFilerResult(
      params.deal.id,
      this.name,
      datedDateFilterPassed
    );
    return datedDateFilterPassed;
  }
}
